/**
 * Event names for duration tracking
 */
export const EVENT_NAMES = {
  VIEW_LOAD_PERFORMANCE: 'View load performance',
} as const;

/**
 * Default max lifetime for session cleanup: 5 minutes
 */
export const DEFAULT_MAX_LIFETIME = 5 * 60 * 1000;

/**
 * Max lifetime per event name (in milliseconds)
 * Sessions that exceed this lifetime will be automatically cleaned up
 */
export const MAX_LIFETIME_BY_EVENT: Record<string, number> = {
  [EVENT_NAMES.VIEW_LOAD_PERFORMANCE]: DEFAULT_MAX_LIFETIME,
};
